import { queryStore } from './queryStore'

const vmixHost = queryStore('vmix_host')
const vmixPort = queryStore('vmix_port')

const sdpUrl = queryStore('sdp_url')
const sdpApp = queryStore('sdp_app')
const sdpStream = queryStore('sdp_str')

export {
	vmixHost,
	vmixPort,
	sdpUrl,
	sdpApp,
	sdpStream,
}
